<div class="row bg-secondary">
  <div class="pr-4 pl-4 mb-2 mt-2">
    <form class="flex-row" (ngSubmit)="filterItems()">
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="searchText" i18n>Item Search</label>
        </div>
        <input id="searchText" name="searchText" class="form-control" [(ngModel)]="itemFilter.searchText">
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="itemTypes" i18n>Type</label>
        </div>
        <select name="itemTypes" id="itemTypes" class="form-control select-bidit" (ngModelChange)="onItemTypeChange($event)" [(ngModel)]="itemFilter.itemTypeId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let type of itemTypes" [(ngValue)]="type.itemType_ID">{{type.itemType_Desc}}</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="rValues" i18n>R-Value</label>
        </div>
        <select name="rValues" id="rValues" class="form-control select-bidit" [(ngModel)]="itemFilter.rValueId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let rvalue of rValues" [(ngValue)]="rvalue.rValue_ID">{{rvalue.rValue_Desc}}</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="statusId" i18n>Status</label>
        </div>
        <select name="statusId" id="statusId" class="form-control select-bidit" [(ngModel)]="itemFilter.statusId">
          <option [ngValue]="null" selected="" i18n>All</option>
          <option [ngValue]="1" i18n>Active</option>
          <option [ngValue]="0" i18n>Inactive</option>
        </select>
      </div>
      <div class="form-group">
        <label for="btnsDiv">&nbsp;</label>
        <div id="btnsDiv">
          <button class="btn btn-md btn-bidit-action mr-2" type="submit" i18n>Apply Filter</button>
          <button class="btn btn-secondary btn-md mr-2" type="button" (click)="initializeSearchCriteria()" i18n>Reset</button>
          <button class="btn btn-bidit-action mr-2" type="button" (click)="exportItems()" i18n>Export</button>
          <button *ngIf="showBulkUpdate" class="btn btn-bidit-cancel btn-md mr-2" type="button" (click)="bulkUpdate()" i18n>Bulk Change</button>
          <button *ngIf="showItemPush" class="btn btn-bidit-cancel btn-md" type="button" (click)="pushItems()" i18n>Push Items</button>
          <button class="btn btn-bidit-action btn-md" type="button" (click)="itemImport()" i18n>Import Items</button>
        </div>
      </div>
    </form>
  </div>
</div>
<app-spinner [isRunning]="isRequesting"></app-spinner>
<div *ngIf="showItemTypePush">{{this.processingStageMessage}}</div>
<div *ngIf="this.showPushProcessingMsg">
  <div>{{this.processingStageMessage}}</div>
  <div>Item Groups To Process: {{this.chunksToProcess}}</div>
  <div>Item Groups Completed Processing: {{this.groupsProcessed}}</div>
  <div>Records Modified: {{this.rowsModified}}</div>
  <div>Item Groups in Error: {{this.groupsErrored}}</div>
  <button [disabled]="this.isRequesting" class="btn btn-bidit-action btn-md me-5" type="button" (click)="hideProcessingMsg()" i18n>Clear Processing Msg</button>

</div>
<div class="bg-white pt-3">
  <div class="col-sm-9"><h5>Items</h5></div>
  <div class="row">
    <div class="col-sm-9" i18n>Unique material codes you use on projects (unique SLI and/or vendor code).</div>
    <div class="col-sm-3">
      <a (click)="showEdit(null)" class="float-right btn btn-bidit-navigate btn-md mb-sm-3" i18n>Add</a>
    </div>
  </div>

  <mat-table class="table compact table-bidit table-hover table-striped" [dataSource]="dataSource"
             matSort matSortActive="item_Name" matSortDirection="asc">
    <ng-container matColumnDef="item_Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Item</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{item.item_Name}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="rValue_Desc">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>R-Value</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{item.rValue_Desc}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="itemType_Desc">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Item Type</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{item.itemType_Desc}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="item_Part">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Orig Mfg. Part</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{item.item_Part}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="external_Item_Part">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Mfg. Part</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{item.external_Item_Part}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <div class="form-inline">
          <label id="item_status_active{{item.item_ID}}" [ngClass]="{'text-success' : item.item_isActive}">active</label>
          <input (change)="toggleStatus('IDIItemSource', item.item_ID)" type="checkbox" name="item_status_{{id}}" id="item_status_{{id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!item.item_isActive" (ngModelChange)="item.item_isActive = $event">
          <label id="item_status_inactive{{item.item_ID}}" [ngClass]="{'text-danger' : !item.item_isActive}">inactive</label>
          <a class="btn-bidit-edit-dark ml-4" (click)="showEdit(item.item_ID)"></a>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <mat-paginator [length]="items?.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
</div>
